import { createReducer } from '@reduxjs/toolkit';
import { actions, setGridType } from './actions';
const initialState = {
    isLoading: false,
    isLoaded: false,
    newsEvents: null,
    gridType: '',
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.request, (state) => ({
        ...state,
        isLoading: true,
    }))
        .addCase(actions.success, (state, action) => {
        const { results, offset } = action.payload.data;
        const { meta } = action;
        const isPaginationEnabled = meta?.isPaginationEnabled || false;
        if (isPaginationEnabled) {
            return {
                ...state,
                newsEvents: action.payload.data,
                isLoaded: true,
                isLoading: false,
            };
        }
        return {
            ...state,
            newsEvents: {
                ...state.newsEvents,
                ...action.payload.data,
                results: offset > 0 ? [...(state.newsEvents?.results || []), ...results] : results,
            },
            isLoaded: true,
            isLoading: false,
        };
    })
        .addCase(actions.failure, (state) => ({
        ...state,
        isLoading: false,
        isLoaded: true,
    }))
        .addCase(setGridType, (state, action) => ({
        ...state,
        gridType: action.payload,
    }));
});
